export const textVideo = () => {
    const videoServices = process.env.VUE_APP_ALLOWED_VIDEO_SERVICES;
    if (!videoServices) {
        return "Service is not available";
    }
    const serviceMap = {
        youtube: "Youtube.com",
        rutube: "Rutube.ru",
        vkvideo: "Vkvideo.ru"
    };
    const services = videoServices
        .split(",")
        .map((s) => s.trim())
        .filter((s) => serviceMap[s])
        .map((s) => serviceMap[s]);
    if (services.length === 0) {
        return "Service is not available";
    }
    const lastService = services.pop();
    const prefix = services.length > 0 ? `${services.join(", ")} and ` : "";
    return `Use only video services: ${prefix}${lastService}`;
};
export const supportedVideo = () => {
    return process.env.VUE_APP_ALLOWED_VIDEO_SERVICES;
};
export const accessVideoLink = (value) => {
    if (!value?.trim()) {
        return "";
    }
    if (!supportedVideo()) {
        return "";
    }
    const allowedServices = supportedVideo()
        .split(",")
        .map((s) => s.trim());
    if (!allowedServices.includes("youtube") ||
        !allowedServices.includes("rutube") ||
        !allowedServices.includes("vkvideo")) {
        return "";
    }
    return value;
};
export const convertVideoLink = (value) => {
    let link = "";
    if (!value) {
        return "";
    }
    if (!supportedVideo()) {
        return "";
    }
    const allowedServices = supportedVideo()
        .split(",")
        .map((s) => s.trim());
    // Проверяем, является ли строка валидным URL
    let url;
    try {
        url = new URL(value);
    }
    catch (error) {
        return "";
    }
    const hostname = url.hostname;
    // YouTube
    if ((hostname.includes("youtube.com") || hostname.includes("youtu.be")) &&
        allowedServices.includes("youtube")) {
        if (url.pathname.startsWith("/embed/")) {
            return value;
        }
        if (url.pathname.includes("/watch")) {
            const videoId = url.searchParams.get("v");
            if (videoId) {
                link = `https://www.youtube.com/embed/${videoId}`;
            }
        }
        else if (hostname.includes("youtu.be")) {
            const videoId = url.pathname.substring(1);
            if (videoId) {
                link = `https://www.youtube.com/embed/${videoId}`;
            }
        }
    }
    // Rutube
    else if (hostname.includes("rutube.ru") &&
        allowedServices.includes("rutube")) {
        if (url.pathname.startsWith("/play/embed/")) {
            return value;
        }
        const pathParts = url.pathname.split("/");
        const videoIndex = pathParts.indexOf("video");
        if (videoIndex !== -1 && pathParts.length > videoIndex + 1) {
            const videoId = pathParts[videoIndex + 1];
            if (videoId) {
                link = `https://rutube.ru/play/embed/${videoId}/`;
            }
        }
    }
    // VK Video
    else if (hostname.includes("vkvideo.ru") &&
        allowedServices.includes("vkvideo")) {
        if (url.pathname === "/video_ext.php") {
            return value;
        }
        const pathParts = url.pathname.split("/");
        const lastPart = pathParts[pathParts.length - 1];
        if (lastPart.startsWith("video-")) {
            const videoInfo = lastPart.replace("video-", "");
            const [ownerId, videoId] = videoInfo.split("_");
            if (ownerId && videoId) {
                let oid = ownerId;
                if (ownerId.startsWith("-")) {
                    oid = ownerId;
                }
                else {
                    oid = `-${ownerId}`;
                }
                link = `https://vkvideo.ru/video_ext.php?oid=${oid}&id=${videoId}`;
            }
        }
    }
    return link;
};
